module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-assigned-by-me-active.abb1b2fc.svg";